const Burndown = () => import("@/components/alfred/Burndown.vue");
const DataBridge = () => import("@/components/alfred/Databridge.vue");
const KPI = () => import("@/components/alfred/Kpi.vue");
const Refinement = () => import("@/components/alfred/Refinement.vue");

export default [
  {
    path: "burndown",
    name: "Burndown",
    component: Burndown,
  },
  {
    path: "databridge",
    name: "DataBridge",
    component: DataBridge,
  },
  {
    path: "refinement",
    name: "Refinement",
    component: Refinement,
  },
  {
    path: "kpi",
    name: "KPI",
    component: KPI,
  },
];
